import { render } from "./PostponedTaskRow.vue?vue&type=template&id=44e5b6da&ts=true"
import script from "./PostponedTaskRow.vue?vue&type=script&lang=ts"
export * from "./PostponedTaskRow.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__